import { collection, CollectionReference } from 'firebase/firestore';
import { FIREBASE_DB } from './config';
import { FirebaseError } from './errors';

export const Collections = {
  JOBS: 'jobs',
  SUPPLIERS: 'suppliers',
  RESOURCES: 'resources',
  FORUM: 'forum',
  JOB_SEEKERS: 'job-seekers'
} as const;

export type CollectionName = typeof Collections[keyof typeof Collections];

export function getCollection(name: CollectionName): CollectionReference {
  try {
    return collection(FIREBASE_DB, name);
  } catch (error) {
    throw new FirebaseError(`Failed to get collection ${name}`);
  }
}